import {
  endOfDay,
  endOfMonth,
  endOfWeek,
  endOfToday,
  endOfYear,
  startOfDay,
  startOfMonth,
  startOfToday,
  startOfWeek,
  startOfYear,
  subDays,
  subMonths,
  subYears,
} from "date-fns";
import { DATE_RANGE } from "./constants";

export const buildPresetRanges = () => {
  const today = new Date();
  const weekOpts = { weekStartsOn: 1 };

  return {
    [DATE_RANGE.today]: { start: startOfToday(), end: endOfToday() },
    [DATE_RANGE.yesterday]: {
      start: startOfDay(subDays(today, 1)),
      end: endOfDay(subDays(today, 1)),
    },
    [DATE_RANGE.last_7]: {
      start: startOfDay(subDays(today, 6)),
      end: endOfToday(),
    },
    [DATE_RANGE.last_14]: {
      start: startOfDay(subDays(today, 13)),
      end: endOfToday(),
    },
    [DATE_RANGE.last_30]: {
      start: startOfDay(subDays(today, 29)),
      end: endOfToday(),
    },
    [DATE_RANGE.this_week]: {
      start: startOfWeek(today, weekOpts),
      end: endOfToday(),
    },
    [DATE_RANGE.last_week]: {
      start: startOfWeek(subDays(today, 7), weekOpts),
      end: endOfWeek(subDays(today, 7), weekOpts),
    },
    [DATE_RANGE.this_month]: {
      start: startOfMonth(today),
      end: endOfToday(),
    },
    [DATE_RANGE.last_month]: {
      start: startOfMonth(subMonths(today, 1)),
      end: endOfMonth(subMonths(today, 1)),
    },
    [DATE_RANGE.this_year]: {
      start: startOfYear(today),
      end: endOfToday(),
    },
    [DATE_RANGE.last_year]: {
      start: startOfYear(subYears(today, 1)),
      end: endOfYear(subYears(today, 1)),
    },
  };
};

export const getDateRangeFromPreset = (presetKey) => {
  const range = buildPresetRanges()[presetKey];
  if (!range) {
    return null;
  }

  return {
    startDateTime: range.start,
    endDateTime: range.end,
  };
};
